<template>

	<div class="container main-content">
		<div class="row">
			<div class="col-12 col-md-7">
				<div class="row mb-4">
					<div class="col-12 text-center">
						<h4 class="dark-highlight mb-5">Camera Verification</h4>
						<p>Please provide a photo of yourself holding up a piece of photo ID.  Ensure the photo is clear and your ID is easily readable.</p>
					</div>
				</div>
				<div class="row">
					<div class="col-12">
						<div class="row">
							<div class="col-12 webcam-container text-center no-padding">
								<div class="mt-5" v-show="!cameraInitialized">
									<div style="">Enabling camera... <i class="fas fa-circle-notch fa-spin"></i></div>
									<transition name="rate-hold-timer-anim" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
									<div class="pt-1" v-show="enableCameraTimeout"><small><a href="#" class="" v-on:click.prevent="$router.push('image-input-upload')">Camera not detecting?  Upload your picture here.</a></small></div>
									</transition>
								</div>
								<vue-web-cam
									v-show="showCamera"
									ref="webcam"
									:device-id="deviceId"
									width="100%"
									height="100%"
									@started="onStarted"
									@stopped="onStopped"
									@error="onError"
									@cameras="onCameras"
									@camera-change="onCameraChange"
								/>
								<div v-show="img != null" class="" style="width: 100%">
									<img :src="img" class="img-responsive" style="width: 100%"/>
								</div>
							</div>
							
						</div>

						<div class="row">
							<div class="col-md-12 mt-3">
								<select class="form-control" v-model="camera" v-if="devices.length > 1">
									<option>-- Select Device --</option>
									<option
										v-for="device in devices"
										:key="device.deviceId"
										:value="device.deviceId"
									>{{ device.label }}</option>
								</select>
							</div>
						</div>
						<div class="row">

						<template v-if="showCamera" >
							<div class="col-12 mt-3 text-center">
								<a href="#" v-bind:class="[cameraInitialized ? '' : 'disabled', 'btn next-btn']" @click="onCapture">Take Picture</a>
							</div>
						</template>
						<template v-else>
							<div class="col-12 col-lg-6 mt-3 pr-0 pl-0">    
								<a href="#" v-bind:class="[isProcessing ? 'disabled' : '', 'btn btn-rounded btn-rounded-primary']"  class="" @click="retake"><i class="fas fa-redo-alt"></i>&nbsp;&nbsp;Retake</a>
							</div>
							<div class="col-12 col-lg-6 mt-3 pr-0 pl-0">
								<a href="#" v-if="!isProcessing" class="btn btn-rounded btn-rounded-primary" @click.prevent="uploadImage">Submit Picture</a>
								<a href="#" v-else class="btn btn-rounded btn-rounded-primary disabled">{{ processingMsg }}... <i class="fas fa-circle-notch fa-spin"></i></a>
							</div>

						</template>

							<div v-if="!cameraInitialized" class="col-12 text-center mt-3">
								<small><a href="#" class="" v-on:click.prevent="$router.push('image-input-upload')">Don't have a camera?  Upload your picture here.</a></small>
							</div>

						</div>
					</div>
				</div>
			</div>
			<div class="col-12 pt-5 pt-md-0 pl-0 offset-md-1 col-md-4 info-text">

				<h5 class="mb-4">Instructions</h5>

				<img class="w-100 mb-2" src="./../assets/img/selfie_example.jpg">
			
				<ol class="mb-4 pl-3 small">
					<li class="mb-2 pl-1"><strong>Must have photo ID in picture</strong> along with your face clearly visible</li>
					<li class="mb-2 pl-1"><strong>First</strong> and <strong>last name</strong> clearly visible on photo ID</li>
					<li class="mb-2 pl-1"><strong>Fully in frame</strong>, not cut off on any side</li>
				</ol>
				<hr />
				<p class="mb-2 small"><strong>List of Valid Government Issued Photo ID</strong></p>
				<ul class="pl-4 mb-4 small">
					<template v-if="$gstate.getActiveCountry() == 'AU'">
					<li class="mb-1">Australian Drivers License</li>
					<li class="mb-1">Australian ID Card</li>
					<li class="mb-1">Australian Passport</li>
					<li class="mb-1">Australian Residence Permit</li>
					</template>
					<template v-else>
					<li class="mb-1">Drivers License issued in Canada</li>
					<li class="mb-1">Canadian Passport</li>
					<li class="mb-1">Certificate of Canadian Citizenship (with photo)</li>
					<li class="mb-1">Permanent Resident Card</li>
					</template>
				</ul>

				<div class="row panel-warning p-3 mb-3" style="margin: 0 10px;">
					<div class="col-12 col-lg-2 text-center">
						<div class="exclamation" alt="Exclamation"></div>
					</div>
					<div class="col-12 col-lg-10 text-center text-lg-left text-warning">
						<small>Please follow the photo instructions carefully. Submitting only an image of your ID will not be accepted!</small>
					</div>
				</div>

				<p class="ml-2">
					<small><a href="#" class="" v-on:click.prevent="$router.push('image-input-upload')">Don't have a camera?  Upload your picture here.</a></small>
				</p>

			</div>
		</div>
		
		
	
	</div>

</template>

<script>

import { eventBus } from './../main'

export default {
	
	data() {
		return {
			bi: this.$gstate.getBuyerInfo(),
			isProcessing: false,
			hasError: false,
			errorMessage: '',
			timeout: null,
			img: null,
			camera: null,
			deviceId: null,
			devices: [],
			mobileNumber: this.$gstate.getBuyerInfo().mobile,
			showCamera: true,
			cameraInitialized: false,
			isVerifyingMobile: false,
			enableCameraTimeout: false,
		}
	},
	mounted(){

	},
	computed: {
		device: function() {
			return this.devices.find(n => n.deviceId === this.deviceId);
		},
		processingMsg: function() {
			if(!this.isProcessing){
				return "Submit";
			} else {
				if(this.isVerifyingMobile){
					return "Verifying";
				} else {
					return "Uploading";
				}
			}
		}
	},
	watch: {
		camera: function(id) {
			this.deviceId = id;
		},
		devices: function() {
			// Once we have a list select the first one
			const [first, ...tail] = this.devices;
			
			if (first) {
				this.camera = first.deviceId;
				this.deviceId = first.deviceId;
			}
		}
	},
	mounted(){

		setTimeout(() => {
			this.enableCameraTimeout = true;
			
		}, 5000);
	},
	methods: {
		retake() {
			this.img = null;
			this.showCamera = true;
		},
		onCapture() {
			this.img = this.$refs.webcam.capture();
			this.showCamera = false;
		},
		onStarted(stream) {
			this.$gstate.log("On Started Event", stream);
			this.cameraInitialized = true;
		},
		onStopped(stream) {
			this.$gstate.log("On Stopped Event", stream);
		},
		onStop() {
			this.$refs.webcam.stop();
		},
		onStart() {
			this.$refs.webcam.start();
		},
		onError(error) {
			this.$gstate.log("On Error Event", error);
		},
		onCameras(cameras) {
			this.devices = cameras;
			this.$gstate.log("On Cameras Event", cameras);
		},
		onCameraChange(deviceId) {
			this.deviceId = deviceId;
			this.camera = deviceId;
			this.$gstate.log("On Camera Change Event", deviceId);
		},
		uploadImage(){

			this.isProcessing = true;

			var urlstr = this.$gstate.getApiBaseURL() + '/selfieimage';
			var mobile = this.mobileNumber.countryCode + this.mobileNumber.areaCode + this.mobileNumber.phoneNumber;
			this.axios.post(urlstr, {
				refId: this.$gstate.getRefId(),
				mobileNumber : mobile,
				documentType : 'SELFIE',
				mimeType : 'image/jpeg',
				fileName : mobile + "_selfie",
				extName : 'jpg',
				encodedFile : this.cleanBase64(this.img),
				imageSource : 'WEBCAM',
			}, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.$gstate.log("done");
					this.$gstate.log(response);

					this.onStop();
					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {

					this.$gstate.log("error:");
					this.$gstate.log(error.response);
					this.hasError = true;
					this.isUploading = false;
					this.isProcessing = false;

					if(error.response){
						this.errorMsg = error.response.data.error.msg;
					} else {
						this.errorMsg = "Internal Server Error.  Please contact support for further assistance."
					}

				});
		},
		cleanBase64(data){
			return data.substr(data.indexOf(',')+1);
		},
	}
}
</script>
